import {
  isValidationErrorMessage,
  type TValidationErrorItem,
} from './get-api-error-message';

type TApiErrorData = {
  message: string | TValidationErrorItem[];
};

export const isErrorWithData = (
  error: unknown,
): error is { status: number; data: TApiErrorData } =>
  typeof error === 'object' &&
  error !== null &&
  'status' in error &&
  typeof error?.status === 'number' &&
  'data' in error &&
  typeof error?.data === 'object' &&
  error?.data !== null &&
  'message' in error?.data &&
  isValidationErrorMessage(error.data.message);
